module.exports = __webpack_public_path__ + "static/media/carrobrasil.c6ba1689.png";